/*
  Pocket: small confirmations around the slide cart.

  - The line just added glows briefly when the slide cart opens.
  - The free postage bar fills from where it was instead of jumping, and its
    star pops the moment postage becomes free.
  - The subtotal pulses when it changes.
  - The header bag nudges once when the slide cart closes after an add, so
    shoppers see where their lamp went.

  Everything hangs off the theme's own cart events (pubsub.js) and changes
  nothing about how the cart works. Styles live in pocket-overrides.css, and
  every effect is skipped for shoppers whose phone asks for reduced motion.
*/
(() => {
  const drawer = document.querySelector('cart-drawer');
  const drawerContents = document.getElementById('CartDrawer');
  if (!drawer || !drawerContents || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DRAWER_SLIDE_MS = 260;

  const progressBar = () => drawer.querySelector('.cart-progress__bar__progress');
  const progressValue = () => {
    const bar = progressBar();
    return bar ? parseFloat(bar.style.width) || 0 : 0;
  };
  const subtotalText = () => {
    const el = drawer.querySelector('.totals__subtotal-value');
    return el ? el.textContent.trim() : '';
  };

  let lastProgress = progressValue();
  let lastSubtotal = subtotalText();
  let addedVariantId = null;
  let awaitingAddRender = false;
  let bagArming = false;
  let bagArmed = false;

  // Re-runs a one-shot CSS animation class, even if it is still on the element.
  const replay = (el, className) => {
    if (!el || reducedMotion.matches) return;
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
    el.addEventListener('animationend', () => el.classList.remove(className), { once: true });
  };

  const fillProgress = (delay) => {
    const bar = progressBar();
    const from = lastProgress;
    const to = progressValue();
    lastProgress = to;
    if (!bar || from === to || reducedMotion.matches) return;

    // The new bar arrives already at its final width; rewind it to the old
    // width, then let the stylesheet's width transition carry it forward.
    bar.style.transition = 'none';
    bar.style.width = `${from}%`;
    void bar.offsetWidth;
    setTimeout(() => {
      bar.style.transition = '';
      bar.style.width = `${to}%`;
      if (to >= 100 && from < 100) {
        bar.addEventListener('transitionend', () => replay(drawer.querySelector('.cart-progress'), 'is-unlocked'), { once: true });
      }
    }, delay);
  };

  const pulseSubtotal = (delay) => {
    const now = subtotalText();
    const changed = now !== lastSubtotal;
    lastSubtotal = now;
    if (changed) setTimeout(() => replay(drawer.querySelector('.totals__subtotal-value'), 'is-updated'), delay);
  };

  const glowAddedLine = () => {
    if (!addedVariantId) return;
    const input = drawer.querySelector(`.quantity__input[data-quantity-variant-id="${CSS.escape(addedVariantId)}"]`);
    addedVariantId = null;
    replay(input && input.closest('.cart-item'), 'is-just-added');
  };

  // Note which lamp is being added. Capture phase, so this runs before the
  // theme's own submit handler; the sticky Add to Cart submits the same form.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;
    const idInput = form.querySelector('[name="id"]');
    addedVariantId = idInput ? idInput.value : null;
  }, true);

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === 'product-form') {
      // The theme announces the add first, then swaps in the new slide cart.
      awaitingAddRender = true;
      setTimeout(() => { awaitingAddRender = false; }, 8000);
    } else if (event.source === 'cart-items') {
      // Quantity changes and removals: the new contents are already in place.
      fillProgress(0);
      pulseSubtotal(0);
    }
  });

  new MutationObserver(() => {
    if (!awaitingAddRender) return;
    awaitingAddRender = false;
    glowAddedLine();
    fillProgress(DRAWER_SLIDE_MS);
    pulseSubtotal(DRAWER_SLIDE_MS);
    bagArming = true;
  }).observe(drawerContents, { childList: true });

  new MutationObserver(() => {
    const open = drawer.classList.contains('active');
    if (open && bagArming) {
      bagArming = false;
      bagArmed = true;
    } else if (!open && bagArmed) {
      bagArmed = false;
      replay(document.getElementById('cart-icon-bubble'), 'is-nudged');
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
